export const UPDATE_STATUS_RECEIVED = 'UPDATE_STATUS_RECEIVED';
export const UPDATE_DIALOG_DISMISSED = 'UPDATE_DIALOG_DISMISSED';
export const UPDATE_DIALOG_REOPENED = 'UPDATE_DIALOG_REOPENED';

export function updateStatusReceived(status){
	return { type: UPDATE_STATUS_RECEIVED, status };
}

export function dismissUpdateDialog(){
	return { type: UPDATE_DIALOG_DISMISSED };
}

export function reopenUpdateDialog(){
	return { type: UPDATE_DIALOG_REOPENED };
}

export function subscribeToUpdateStatus(){
	return async (dispatch) => {
		if(!window.bodapro?.onUpdateStatus) return;

		window.bodapro.onUpdateStatus((status) => {
			dispatch(updateStatusReceived(status));
		});

		const status = await window.bodapro.getUpdateStatus();
		if(status) dispatch(updateStatusReceived(status));
	};
}

export function checkForUpdate(){
	return async (dispatch) => {
		await window.bodapro.checkForUpdate();
	};
}

export function downloadUpdate(){
	return async (dispatch) => {
		return window.bodapro.downloadUpdate();
	};
}

export function installUpdate(){
	return async (dispatch) => {
		return window.bodapro.installUpdate();
	};
}
